import React, { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { useAccount } from '../../../../hooks/useAccount';
import SettingsPageLayout from '../../../../layouts/settings/settingsPageLayout';
import { ApiApp } from '../../../../services/models/api-app';
import { AppType } from '../../../../services/models/app-type';

const ApiIntegrationPage: FunctionComponent = () => {
  const { account } = useAccount();
  const apiApps: ApiApp[] = account?.apiApps || [];
  const apiApp = apiApps.find(x => x.type === AppType.Api);

  if (!apiApp) return <Redirect to="/dashboard/settings/integrations" />;

  return (
    <SettingsPageLayout title="API | Newslit">
      <div className="mt-10 divide-y divide-gray-200">
        <div className="space-y-1">
          <h3 className="text-lg leading-6 font-bold text-gray-900">API Integration</h3>
          <p className="max-w-2xl text-sm text-gray-500 m-0">
            Integrate your briefs into your application or website through a single API
          </p>
        </div>

        <div className="mt-6">
          <dl className="divide-y divide-gray-200">
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-medium text-gray-500">API Key</dt>
              <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <span className="grow">
                  <code>{apiApp.apiKey}</code>
                </span>
              </dd>
            </div>
          </dl>
          <p className="text-gray-600 font-normal mt-4">
            For more information on the API please see our{' '}
            <a
              rel="noopener noreferrer"
              href="https://hackmd.io/@newslit/r19VgU7GB"
              target="_blank"
              className="font-bold"
            >
              API documentation
            </a>
          </p>
        </div>
      </div>
    </SettingsPageLayout>
  );
};

export default ApiIntegrationPage;
